<template>
  <div class="product fs-16 product-type">
    <div class="tab-mol">
      <el-carousel height="300px" indicator-position="none" :autoplay="false" :arrow="typeList.length > 1 ? 'hover' : 'never'" :loop="false">
        <el-carousel-item v-for="(item, i) in typeList" :key="i">
          <ul class="type-list">
            <li v-for="(o, j) in item" :key="j" @click="changeType(o)">
              <div class="img-icon">
                <img :src="o.pictureUrl" v-if="o.pictureUrl"/>
              </div>
              <p class="bold mt-20">{{o.sortName}}</p>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="cont">
      <template v-if="dataList.length">
        <div class="pt-60 tt-1">选购{{itemData.sortName}}</div>
        <div class="pt-30 fs-26 bold">全部型号，<span class="col-gray">随你挑。</span></div>
        <div class="carousel-mol">
          <el-carousel height="534px" indicator-position="none" :autoplay="false" :arrow="dataList.length > 1 ? 'hover' : 'never'" :loop="false">
            <el-carousel-item v-for="(item, j) in dataList" :key="j">
              <ul class="p-type-list" style="padding: 20px 60px">
                <li v-for="(o, i) in item" :key="i" @click="goDetail(o)">
                  <div>
                    <div class="bold t-overflow pb-20">{{o.productName}}</div>
                    <div class="img-icon">
                      <img :src="o.frontCover" v-if="o.frontCover"/>
                    </div>
                    <div class="a-foot pt-20">
                      <span>RMB {{o.sellingPrice}} 起</span>
                      <el-button type="primary" class="btn-1" round>购买</el-button>
                    </div>
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </template>
      <div class="pt-30 fs-26 bold">导购来了，<span class="col-gray">怎么选？看这里</span></div>
      <ul class="p-type-list guide-mol">
        <li>
          <div @click="goCompare">
            <div class="bold tt">看哪款{{itemData.sortName}}<br/>更适合您的猪场？</div>
            <span class="tts">比较所有型号</span>
            <div class="img-icon">
              <img :src="itemData.pictureUrl"/>
            </div>
          </div>
        </li>
        <li>
          <div @click="goConsult">
            <div class="bold tt">如果您决定不了，<br/>可电话or留言咨询。</div>
            <span class="tts">协助选购</span>
            <div class="img-icon">
              <img src="../../assets/images/product/procenter_mod4.png"/>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'productDevType',
  data () {
    return {
      query: this.$route.query,
      typeList: [],
      activeUuid: '',
      itemData: {},
      dataList: []
    }
  },
  mounted () {
    this.getTypeList()
  },
  methods: {
    getTypeList () {
      if (!this.query.id) {
        return
      }
      this.API.product.getProductTypeList({
        currentPage: 1,
        pageSize: 500,
        sortLevel: 2,
        showFlag: 1,
        sort: 0,
        sortLevelParentUuid: this.query.id
      }).then((res) => {
        let data = res.data || []
        if (data.length) {
          this.changeType(data[0])
          this.typeList = _.chunk(data, 5)
        }
      })
    },
    changeType (o) {
      this.activeUuid = o.sortUuid
      this.itemData = o
      this.API.product.getProductList({
        currentPage: 1,
        pageSize: 500,
        status: 1,
        sortUuid: this.activeUuid
      }).then((res) => {
        let data = res.data || []
        this.dataList = _.chunk(data, 3)
      })
    },
    goCompare () {
      if (!this.activeUuid) {
        // return
      }
      this.$router.push({
        name: 'productCompare',
        query: {
          id: this.activeUuid,
          sortName: this.itemData.sortName
        }
      })
    },
    goDetail (o) {
      this.$router.push({
        name: 'productDetail',
        query: {
          id: o.uuid
        }
      })
    },
    goConsult () {
      this.$router.push({
        name: 'consult'
      })
    }
  }
}
</script>
